import React from "react"
import {MainCP} from "../../Components/figuras-publicas/MainCP"

const ViewFigurasPublicas: React.FC = () => <MainCP/>

export default ViewFigurasPublicas;